import IconButton from "@material-ui/core/IconButton";
import React from "react";
import { withStyles, responsiveFontSizes } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const CustomIconButtonV2 = ({ classes, size, style, title, ...props }) => (
  <IconButton className={`${classes[size]} ${style}`} {...props} />
);

const styles = {
  small: {
    "& svg": {
      fontSize: 18,
    },
    color: "#555A6C",

    " &:focus ": {
      outline: "none",
    },
  },
  medium: {
    "& svg": {
      fontSize: 24,
    },
    color: "#555A6C",

    " &:focus ": {
      outline: "none",
    },
  },
  large: {
    "& svg": {
      fontSize: 32,
    },
    color: "#555A6C",

    " &:focus ": {
      outline: "none",
    },
  },
  customWidth: {
    margin: 0,
    padding: 3,
  },
};

export default withStyles(styles)(CustomIconButtonV2);
